<template>
  <el-form
    ref="form"
    v-loading="loading"
    :model="form"
    :rules="rules"
    label-width="80px"
    inline
    style="display: flex; flex-direction: column"
  >
    <div>
      <el-form-item label="产品编码">
        <el-input :value="form.fNumber" readonly />
      </el-form-item>
      <el-form-item label="产品名称">
        <el-input :value="form.fName" readonly />
      </el-form-item>
      <el-form-item label="总数 ">
        <el-input :value="form.fTotalQty" readonly />
      </el-form-item>
      <el-form-item v-if="canEdit">
        <el-button type="primary" :disabled="saving" @click="submit"
          >保存<span v-if="saving">中...</span></el-button
        >
      </el-form-item>
    </div>
    <el-table :data="form.entrys" style="width: 100%" height="100%">
      <el-table-column label="库存日期" prop="fDate" :formatter="dateFormat" />
      <el-table-column label="批号" prop="fBatchNo" />
      <el-table-column
        label="生产日期"
        prop="fDate_Sc"
        :formatter="dateFormat"
      />
      <el-table-column
        label="消毒日期"
        prop="fDate_Xd"
        :formatter="dateFormat"
      />
      <el-table-column label="追溯号" prop="fRetroactiveNo" />
      <el-table-column label="即时库存" prop="fInventoryQty" />
      <el-table-column
        label="数量"
        label-class-name="font-color-red"
        width="120px"
      >
        <template slot-scope="scope">
          <el-input-currency
            v-model="scope.row.fQty"
            :scale="0"
            min="0"
            @change="fQtyChange"
          />
        </template>
      </el-table-column>
      <el-table-column width="80">
        <template slot="header">
          <div style="display: flex; align-items: center">
            <i
              class="el-icon-circle-plus-outline"
              style="
                color: #409eff;
                font-size: 18px;
                margin-left: 5px;
                cursor: pointer;
              "
              title="添加行"
              @click="addRow"
            />
          </div>
        </template>
        <template slot-scope="scope">
          <div class="tools" v-if="!scope.row.fInventoryID">
            <el-popconfirm title="是否删除？" @confirm="delRow(scope.$index)">
              <i slot="reference" class="el-icon-remove-outline" title="删除" />
            </el-popconfirm>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </el-form>
</template>

<script>
import moment from "moment";
import addForm from "./addForm";

export default {
  components: {
    addForm,
  },
  data: function () {
    return {
      form: {},

      rules: {},

      currentEditItem: null,

      loading: false,
      saving: false,
      isNew: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.routePath || vm.routePath != to.fullPath) {
        vm.routePath = to.fullPath;
        vm.refresh();
      }
    });
  },
  beforeRouteUpdate: function (to, from, next) {
    next();
    const vm = this;
    vm.routePath = to.fullPath;
    vm.refresh();
  },
  computed: {
    canEdit: function () {
      const userGrants = this.$store.state.userInfo.userGrants;
      let grants;
      userGrants.forEach((val) => {
        if (val.key == "004009002") {
          grants = val.isGrant;
        }
      });
      return grants;
    },
  },
  methods: {
    submit: async function () {
      this.saving = true;
      this.$httpPost("BasicInformation/Inventory/InventoryModify", {
        datalist: JSON.stringify(this.form),
      })
        .then((res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message);
            return;
          }

          // 重新刷新页面数据
          this.$message.success(res.message);
          this.refresh(res.datalist);
        })
        .finally(() => (this.saving = false));
    },

    addRow: function () {
      this.currentEditItem = {
        fInventoryID: null,
        fInventoryQty: 0,
        fQty: 0,
      };
      const h = this.$createElement;
      this.$formDlg({
        title: "新增",
        width: "30%",
        formTpl: <addForm form={this.currentEditItem}></addForm>,
        formSubmit: (formData) => {
          this.form.entrys.push(formData);
          this.fTotalQtyRefresh();
        },
      });
    },
    delRow: function (index) {
      this.form.entrys.splice(index, 1);
      this.fTotalQtyRefresh();
    },
    fQtyChange: function () {
      this.fTotalQtyRefresh();
    },

    fTotalQtyRefresh: function () {
      var sum = 0;
      for (let i = 0; i < this.form.entrys.length; i++) {
        const e = this.form.entrys[i];
        sum += Number(e.fQty || 0);
      }
      this.form.fTotalQty = sum;
    },

    refresh: async function (fid) {
      const id = fid || +this.$route.params.id;
      this.isNew = !id;
      if (id == 0) {
        this.form = {
          entrys: [],
        };
        return;
      }

      this.loading = true;
      const res = await this.$httpPost(
        "BasicInformation/Inventory/GetInventoryForICItemInfo",
        {
          fid: id,
        }
      ).finally(() => (this.loading = false));

      if (!res.isSuccess) {
        this.$message.error(res.message);
        return;
      }

      this.form = res.datalist;
    },
    dateFormat: function (row, column, cellValue) {
      var date = cellValue;
      if (date == undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD");
    },
  },
};
</script>

<style lang="less" scoped>
.tools i {
  margin-right: 5px;
  cursor: pointer;
  color: #409eff;
  font-size: 18px;
}
</style>
